import React, { useEffect } from "react";
import './readpeak.m.css';

  function Readpeak() {

      if (typeof document !== 'undefined') {
        var element = document.getElementById("readpeak-tag");

        var tcstring = null;
        tcstring = document.cookie
        .split('; ')
        .find((row) => row.startsWith('TcString='))
        ?.split('=')[1];
        useEffect(()=>{
          window.__rpplc = window.__rpplc || [];
          window.__rpplc.push({
            id: '1b5ae92aeeba4d79',
            width: 980,
            height: 460,
            gdpr_consent: tcstring,
            cats: [],
            tags: [],
            numberOfAds: 3,
          }, element);
        },[])

     }
     return <div styleName="readpeak" id="readpeak-tag"></div>
}

export {Readpeak}
